import { INVENTORY_MODULE } from "@/api_framework/api_config";
import axios from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useAuditTrailExportCSVAPI = () => {
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (filterBody) => {
      try {
        const response = await axios.post(`${INVENTORY_MODULE?.AUDIT_TRAIL_EXPORT_CSV?.baseURL}`, filterBody, {
          headers: {
            "x-audit-api-key": `Z74XW)a0dVszqE3d#=gUmR5=2f7gh5Kh#eQQXtuY&D%nRfeHyJXm_wtGyWdzzQx#(Z5b2`,
            "Content-Type": "application/json",
          },
          responseType: "blob",
        });
        if (response && response.headers["content-type"]?.includes("csv")) {
          const csvContent = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
          const url = window.URL.createObjectURL(csvContent);
          const link = document.createElement("a");
          // const contentDisposition = response.headers["content-disposition"];
          // let fileName = "audit_trail.csv";
          // if (contentDisposition && contentDisposition.includes("filename=")) {
          //   fileName = contentDisposition.split("filename=")[1].replace(/['"]/g, "").trim();
          // }
          link.href = url;
          link.setAttribute("download", "audit_trail.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast.success("CSV Export Successfully of 10 days");
        } else {
          toast.error("CSV Export Failed: No content received");
        }
      } catch (e) {
        sendCurl(e.config["curlCommand"]);
        toast.error("Server Error: " + e.message);
      }
    },
    [sendCurl],
  );
  return { execute };
};